import script from "./RcModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__